<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Listado de Jinetes</div>
      <div slot="sub-title">Jinetes pertenecientes a la escuela</div>
      <div slot="right">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-narrow">
            <b-button icon-left="plus" type="is-primary" @click="openCreateModal">Crear Jinete</b-button>
          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <riders-table @edit="editRider" :reload.sync="reloadTable"/>
    </section>
    <rider-form-modal :active.sync="createModalActive" :rider-id.sync="riderIdSelected" @saved="reloadTable = true"/>
  </div>
</template>

<script>

import HeroBar from '@/components/HeroBar'
import RidersTable from './components/RidersTable'
import RiderFormModal from './components/RiderFormModal'

export default {
  components: {
    HeroBar,
    RidersTable,
    RiderFormModal
  },
  data () {
    return {
      createModalActive: false,
      riderIdSelected: null,
      reloadTable: false
    }
  },
  methods: {
    openCreateModal () {
      this.createModalActive = true
    },
    editRider (data) {
      if (data) {
        this.riderIdSelected = data
        this.createModalActive = true
      }
    }
  }
}
</script>
